var React = require('react');

function Github (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M15.75 33.25C7 35.875 7 28.875 3.5 28M28 38.5v-6.773a5.899 5.899 0 00-1.645-4.567c5.495-.613 11.27-2.695 11.27-12.25A9.52 9.52 0 0035 8.347a8.873 8.873 0 00-.157-6.597S32.776 1.137 28 4.34a23.415 23.415 0 00-12.25 0c-4.777-3.203-6.842-2.59-6.842-2.59a8.872 8.872 0 00-.158 6.597 9.52 9.52 0 00-2.625 6.615c0 9.485 5.775 11.568 11.27 12.25a5.896 5.896 0 00-1.645 4.515V38.5","stroke":"#73808D","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h42v42H0z"})))]);
}

Github.defaultProps = {"width":"42","height":"42","fill":"none"};

module.exports = Github;

Github.default = Github;
